import(/* webpackMode: "eager" */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/app/terms-of-service/page.jsx");
